import "./dashboard";
import "./dashlets";
import "./search/searchList";
import "./search/widgetSearch";
import "./history/historyList";
import "./search/widgetRelation";
